import { yupResolver } from '@hookform/resolvers/yup'
import { Card, Typography, message } from 'antd'
import i18next from 'i18next'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as yup from 'yup'

import { LoginForm } from '@components'
import {
  ENavBarRole,
  PATH_DASHBOARD,
  PATH_FORGOT_PASSWORD,
  PATH_SIGN_UP,
  PATH_TEST_MANAGEMENT,
} from '@configs'
import { BaseResponseError, ILoginFields } from '@interfaces'
import {
  RootState,
  loginAction,
  selectAuthLoading,
  useAppDispatch,
} from '@redux'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { getRedirectPathAfterLoginSuccess } from '@utils'

const schema = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required(i18next.t('error:email_required'))
    .email(i18next.t('error:email_format_error')),
  password: yup.string().required(i18next.t('error:pass_required')),
})

export const LoginPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const [isRemember, setIsRemember] = useState<boolean>(false)

  const loginActionLoading = useSelector((state: RootState) =>
    selectAuthLoading(state, 'loginAction')
  )

  const { control, handleSubmit, setValue } = useForm<ILoginFields>({
    defaultValues: {
      email: '',
      password: '',
    },
    resolver: yupResolver(schema),
  })

  const handleRedirectToForgot = () => {
    navigate(PATH_FORGOT_PASSWORD)
  }

  const handleRedirectToSignUp = () => {
    navigate(PATH_SIGN_UP)
  }

  const handleLogin = handleSubmit(async (data) => {
    try {
      const res = await dispatch(loginAction({ ...data, isRemember })).unwrap()
      if (res?.success) {
        message.success({
          content: i18next.t('login:login_success'),
        })
        // temporarily navigate to test management for teacher role
        if (res?.data?.user?.client === ENavBarRole.ADMIN) {
          const redirectPath = getRedirectPathAfterLoginSuccess({
            defaultPath: PATH_DASHBOARD,
            permissions: res?.data?.user?.role?.permissions,
          })
          navigate(redirectPath || PATH_DASHBOARD)
        } else {
          const redirectPath = getRedirectPathAfterLoginSuccess({
            defaultPath: PATH_TEST_MANAGEMENT,
            permissions: res?.data?.user?.role?.permissions,
          })
          navigate(redirectPath || PATH_TEST_MANAGEMENT)
        }
      }
    } catch (err) {
      const error = err as BaseResponseError
      message.error({
        content: error?.message,
      })
      // reset({ password: '' })
      setValue('password', '')
    }
  })

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Card className="!rounded-2xl  min-[1280px]:w-[400px]">
        <Typography.Title level={3} className="text-left">
          Sign In
        </Typography.Title>
        <LoginForm
          control={control}
          redirectToForgot={handleRedirectToForgot}
          redirectToSignUp={handleRedirectToSignUp}
          handleLogin={handleLogin}
          isLoading={loginActionLoading}
          isRemember={isRemember}
          onRemember={(e: CheckboxChangeEvent) =>
            setIsRemember(e.target.checked)
          }
        />
      </Card>
    </div>
  )
}
